import React from "react";

import { mediaType } from "WEBSOCKET/constants";
import { Modules } from "UTILS/Constants";

export default class BitRateTile extends React.Component {
  constructor(props) {
    super(props);
    this.interval = null;
    this.intervalList = [];
    this.repeatInterval = 2000; // 2000 ms == 2 seconds
    this.state = {
      bitRate: 0
    }
    this.bitrate = {}
  }

  componentDidMount() {
    this.getBitrate();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(prevProps.mediaType !== this.props.mediaType) {
      this.intervalList.forEach(interval => clearInterval(interval))
      this.getBitrate();
    }
  }

  getBitrate = () => {
    this.bitrate = {}
    this.interval = setInterval(() => {
      if(((this.props.module === Modules.SCREENSHARE || this.props.module === Modules.SNAPSHOT) &&
        this.props.wsocketPeer) ||
        ((this.props.module !== Modules.SCREENSHARE && this.props.module !== Modules.SNAPSHOT) &&
        this.props.wsocketPeer[this.props.participantUniqueID] &&
        this.props.wsocketPeer[this.props.participantUniqueID][this.props.mediaType])) {
        let peerConnection = this.props.module === Modules.SCREENSHARE || this.props.module === Modules.SNAPSHOT
          ? this.props.wsocketPeer.peerConnection
          : this.props.wsocketPeer[this.props.participantUniqueID][this.props.mediaType].peerConnection;
        peerConnection &&
        peerConnection.getStats()
        .then((stats) => {
          stats.forEach((res) => {
            if(!res)
              return;
            let resType = "inbound-rtp"
            if(this.props.participantUniqueID == this.props.uniqueId) {
              resType = "outbound-rtp"
            }

            // Check if these are statistics on incoming media
            if (res.type === resType && res.kind === this.props.mediaType.toLowerCase()) {
              const resBytes = this.props.participantUniqueID == this.props.uniqueId
                ? res.bytesSent
                : res.bytesReceived;
              this.bitrate.bsnow = resBytes;
              this.bitrate.tsnow = res.timestampMillis ?? res.timestamp;
              if (typeof this.bitrate.bsbefore === 'undefined') {
                // Skip this round
                this.bitrate.bsbefore = this.bitrate.bsnow;
                this.bitrate.tsbefore = this.bitrate.tsnow;
              } else {
                // Calculate bitrate
                const timePassed = (this.bitrate.tsnow - this.bitrate.tsbefore) / 1000;
                if (timePassed > 0) {
                  const bits = (this.bitrate.bsnow - this.bitrate.bsbefore) * 8;
                  const bitRate = Math.round(bits / timePassed / 1000);
                  this.bitrate.value = bitRate + ' kbits/sec';
                  this.setState({
                    bitRate: bitRate
                  });
                }
                this.bitrate.bsbefore = this.bitrate.bsnow;
                this.bitrate.tsbefore = this.bitrate.tsnow;
              }
            }
          });
        });
      }
    }, this.repeatInterval);
    this.intervalList.push(this.interval);
  }

  render() {
    return (
      <div 
        className = { this.props.hide
          ? "bitrate displayNone"
          : "bitrate"}
        id = {this.props.participantUniqueID}
      >
        {(this.state.bitRate || 0) + ' kbps'}
      </div>
    )
  }

  componentWillUnmount() {
    this.intervalList.forEach(interval => clearInterval(interval))
  }
}